import { Link } from 'react-router-dom';
import { ChevronRightIcon, HomeIcon } from '@heroicons/react/24/outline';
import { BreadcrumbProps, BreadcrumbItem } from '../../types/blog';

const Breadcrumb = ({ items, className = '' }: BreadcrumbProps) => {
  // Always include Home as first item if not already present
  const homeItem: BreadcrumbItem = {
    label: 'Trang chủ',
    href: '/'
  };

  // Check if home is already included
  const hasHome = items.some(item => item.href === '/' || item.label === 'Trang chủ');
  const allItems = hasHome ? items : [homeItem, ...items];

  return (
    <nav className={`flex ${className}`} aria-label="Breadcrumb">
      <ol className="flex items-center space-x-2">
        {allItems.map((item, index) => {
          const isLast = index === allItems.length - 1;
          const isHome = item.href === '/';

          return (
            <li key={`${item.href}-${index}`} className="flex items-center">
              {/* Separator */}
              {index > 0 && (
                <ChevronRightIcon
                  className="flex-shrink-0 h-4 w-4 text-m2-outline mx-2"
                  aria-hidden="true"
                />
              )}

              {/* Breadcrumb item */}
              {isLast || !item.href ? (
                <span className={`text-sm font-medium text-m2-on-surface-variant ${isLast ? 'text-m2-on-surface' : ''}`}>
                  {isHome && (
                    <HomeIcon className="flex-shrink-0 h-4 w-4 mr-1 inline" aria-hidden="true" />
                  )}
                  {item.label}
                </span>
              ) : (
                <Link
                  to={item.href}
                  className="text-sm font-medium text-m2-on-surface-variant hover:text-m2-on-surface transition-colors flex items-center"
                >
                  {isHome && (
                    <HomeIcon className="flex-shrink-0 h-4 w-4 mr-1" aria-hidden="true" />
                  )}
                  {item.label}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumb;